var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relevant-search"},[_c('strong',[_vm._v("相关搜索")]),_c('p',_vm._l((_vm.relationSearch),function(item,index){return _c('a',{key:index,attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.goSearchFromRelevant(item);_vm.countAd(4519)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }